var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-list-view"},[_c('h1',[_vm._v(" Список событий ")]),_c('event-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }